import { Navigate, Route, Routes } from "react-router-dom";
import LandingPage from "../operations/pages/LandingPage/LandingPage";
import OperationHome from "../operations/pages/OperationHome/OperationHome";
import DetailsScreen from "../operations/pages/DetailsPage/DetailsScreen";
import DashboardScreen from "../operations/pages/DashboardScreen/DashboardScreen";
import AgentHome from "../agent/pages/AgentHome/AgentHome";
import AgentImprovement from "../agent/pages/AgentImprovement/AgentImprovement";
import LearningLink from "../agent/components/Learning/LearningLink";
import PerformanceDashboardScreen from "../operations/pages/PerformanceDashboardScreen/PerformanceDashboardScreen";
import AgentDashboard from "../operations/pages/AgentGuideDashboard/AgentDashboard";
import AnalyticsScreen from "../operations/pages/AnalyticsScreen/AnalyticsScreen";
import MontenidoUsage from "../operations/pages/MontenidoUsage/MontenidoUsage";

export const ProtectedRoutes = () => {
  const authToken = localStorage.getItem("authToken");

  const isTokenExpired = () => {
    if (!authToken) return true;

    try {
      const payload = JSON.parse(atob(authToken.split(".")[1]));
      return Date.now() > payload.exp * 1000;
    } catch {
      return true;
    }
  };

  const tokenExpired = isTokenExpired();

  // If token missing or expired → redirect to login
  if (!authToken || tokenExpired) {
    localStorage.removeItem("authToken");
    return <Navigate to="/" replace />;
  }

  return (
    <Routes>
      <Route path="/landing" element={<LandingPage />} />
      <Route path="/operationhome" element={<OperationHome />} />
      <Route
        path="/detailsPage/:memberId/:callId"
        element={<DetailsScreen />}
      />
      <Route path="/dashboardPage" element={<DashboardScreen />} />
      <Route
        path="/performancedashboardPage"
        element={<PerformanceDashboardScreen />}
      />
      <Route path="/agentGuideDashboard" element={<AgentDashboard />} />
      <Route path="/analytics" element={<AnalyticsScreen />} />
      <Route path="/montenido-usage" element={<MontenidoUsage />} />
      <Route path="/agenthome" element={<AgentHome />} />
      <Route
        path="/operationhome/improvementInsight"
        element={
          <AgentImprovement dataAccessor="recommendations" cardHeader="Agent" />
        }
      />
      <Route
        path="/operationhome/processInsight"
        element={
          <AgentImprovement
            dataAccessor="processImprovement"
            cardHeader="Process"
          />
        }
      />
      <Route path="/learninglink" element={<LearningLink />} />

      {/* Unknown protected route */}
      <Route path="*" element={<Navigate to="/landing" replace />} />
    </Routes>
  );
};
